export enum JobPostingCompensationTypesAsNoun {
    hourly = 'hour',
    daily = 'day',
    weekly = 'week',
    monthly = 'month',
    yearly = 'year',
}
